<template>
    <div class="row justify-content-center">
        <b-form @submit.prevent="downloadReport" class="col-xl-8">
            <b-form-group label="Дата от" label-for="date-from">
                <b-form-datepicker id="date-from" v-model="dateFrom" required></b-form-datepicker>
            </b-form-group>
            <b-form-group label="Дата до" label-for="date-to">
                <b-form-datepicker id="date-to" v-model="dateTo" required></b-form-datepicker>
            </b-form-group>
            <b-form-group>
                <b-button type="submit" :disabled="processing">Скачать</b-button>
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
import axios from "axios";
import FileDownloadMixin from "@/components/mixins/FileDownloadMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
    name: "ReportScreen",

    mixins: [
        FileDownloadMixin,
        NotificationMixin,
    ],

    data() {
        return {
            dateFrom: null,
            dateTo: null,
            processing: false,
        };
    },

    methods: {
        downloadReport() {
            if (this.dateFrom && this.dateTo) {
                this.processing = true;
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + '/api/sorting-center/downloadReport',
                    method: 'POST',
                    responseType: 'arraybuffer',
                    data: {
                        from: this.dateFrom,
                        to: this.dateTo,
                    },
                }).then(resp => {
                    this.saveFile(resp);
                }).catch(err => {
                    this.showErrors(err.response.data.errors);
                }).finally(() => {
                    this.processing = false;
                })
            } else {
                this.showErrors('Укажите период');
            }
        },
    },
}
</script>

<style scoped>

</style>